import 'bootstrap/dist/js/bootstrap.bundle.min';
import './js/fancybox.js';
import './js/pretty-drowpdowns.js';
import Swiper from 'swiper/bundle';

jQuery(function($) {

    // Pretty dropdowns
    $('select').prettyDropdown({
        height: 50
    });

    // Wrap table to div
    $('table').wrap('<div class="table-responsive"></div>');

    new Swiper(".partnersSwiper", {
        slidesPerView: 2,
        spaceBetween: 60,
        loop: true,
        navigation: {
            nextEl: ".swiper-partners-next",
            prevEl: ".swiper-partners-prev",
        },
        breakpoints: {
            800: {
                slidesPerView: 4,
                spaceBetween: 60
            },
            1200: {
                slidesPerView: 6,
                spaceBetween: 86
            }
        }
    });

    new Swiper(".indexSwiper", {
        slidesPerView: 'auto',
        spaceBetween: 30,
        navigation: {
            nextEl: ".swiper-index-next",
            prevEl: ".swiper-index-prev",
        },
    });

    new Swiper(".portfolioSwiper", {
        slidesPerView: 'auto',
        spaceBetween: 20,
        navigation: {
            nextEl: ".swiper-portfolio-next",
            prevEl: ".swiper-portfolio-prev",
        },
    });

    $('.swiper-container').each(function(index) {
        var sliderId = $(this).data('slider-id');
        var swiper = new Swiper('.gallerySwiper-' + sliderId, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            navigation: {
                nextEl: ".swiper-next-" + sliderId,
                prevEl: ".swiper-previous-" + sliderId,
            }
        });

        // Add event listeners to custom navigation
        $('.swiper-previous-' + sliderId).on('click', function() {
            swiper.slidePrev();
        });

        $('.swiper-next-' + sliderId).on('click', function() {
            swiper.slideNext();
        });

    });

    // Function to add data attribute based on the option's text content
    function addDataAttribute(selector, textContent) {
        $(selector).each(function() {
            $(this).find('li[role="option"]').each(function() {
                if ($(this).text().trim() === textContent) {
                    $(this).attr('data-placeholder', 'true');
                }
            });
        });
    }

    // Use the "attribute equals" selector to find the input by its name
    var $fileInput = $('input[name="file-profile-picture"]');

    // Trigger the file input box when the custom label is clicked
    $('.custom-file-label').click(function() {
        $fileInput.click();
    });

    // Update the custom text span with the file name upon file selection
    $fileInput.change(function() {
        var fileName = $(this).val().split('\\').pop(); // Extract the file name
        $('#file-chosen').text(fileName ? fileName : 'No file chosen'); // Update the text

        // Optionally, you can hide the 'No file chosen' text when no file is selected
        if (!fileName) {
            $('#file-chosen').hide();
        } else {
            $('#file-chosen').show();
        }
    });

    // Expand upload click area
    $('.codedropz-upload-handler').on('click', function(event) {
        // Ensure the click didn't happen on the button itself
        if (!$(event.target).closest('.cd-upload-btn').length) {
            $('.cd-upload-btn').click();
        }
    });

    $('.read-more').click(function(){
        var $block = $(this).closest('.description');
        
        $block.find('.read-more-text, .read-less-text').toggleClass('disp-none');
        $block.find('.show-read-more, .show-read-less').toggleClass('disp-none');
    });

});

// Reinitialize Swiper when FacetWP loads
jQuery(document).on('facetwp-loaded', function() {
    // Destroy existing Index Swiper instances if any
    if (typeof window.myIndexSwiper !== 'undefined' && window.myIndexSwiper.length > 0) {
        window.myIndexSwiper.forEach(function(swiper) {
            swiper.destroy(true, true);
        });
    }

    // Reinitialize Index Swiper
    window.myIndexSwiper = [];
    jQuery('.indexSwiper').each(function(index, element) {
        window.myIndexSwiper[index] = new Swiper(element, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            navigation: {
                nextEl: ".swiper-index-next",
                prevEl: ".swiper-index-prev",
            },
        });
    });
      
});

jQuery(document).ready(function($) {
    // Function to initialize an observer for a given data name
    function setupObserverForDataName(dataName) {
        var targetNode = document.querySelector('[data-name="' + dataName + '"]');

        // Options for the observer (what mutations to observe)
        var config = {
            attributes: false,
            childList: true,
            subtree: true
        };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                // Handle added nodes
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('wpcf7-not-valid-tip')) {
                            $(targetNode).find('ul').addClass('wpcf7-not-valid');
                        }
                    });
                }
                // Handle removed nodes
                if (mutation.removedNodes.length) {
                    mutation.removedNodes.forEach(function(node) {
                        if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('wpcf7-not-valid-tip')) {
                            $(targetNode).find('ul').removeClass('wpcf7-not-valid');
                        }
                    });
                }
            }
        };

        // Create an instance of the MutationObserver
        var observer = new MutationObserver(callback);

        // Start observing the target node for the configured mutations
        if (targetNode) {
            observer.observe(targetNode, config);
        } else {
            console.log('Target node for observer not found for ' + dataName);
        }
    }

    // Setup observers for both fields
    setupObserverForDataName('specializacijos');
    setupObserverForDataName('miestai');
});